module.exports = __webpack_public_path__ + "img/renbg.d7d4b3dc.jpg";